import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setTimeManagementPage } from 'src/redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useTimeManagementSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getTimeManagementSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website?.time_management_page?.time_management_section}`);
      console.log("🚀 ~ getTimeManagementSectionJson ~ data:", response);
      console.log("🚀 ~ getTimeManagementSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setTimeManagementPage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Time Management section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getTimeManagementSectionJson();
  }, [getTimeManagementSectionJson]);

  return {
    data,
    loading,
    error,
    getTimeManagementSectionJson,
    fetchOnMount,
    refetch: getTimeManagementSectionJson
  };
};

export default useTimeManagementSection;
